import axiosInstance from 'services/axiosMiddleware';

export async function getCoupon() {
  try {
    const response = await axiosInstance.post('coupon/getCoupon');
    return response.data.response;
  } catch (error) {
    if (error.response && error.response.status === 404) {
      return [];
    }
    console.error(error);
    throw error;
  }
}
